"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISO_DATE_FORMAT = exports.SHORT_DATE_FORMAT = exports.LONG_MONTH_DATE_FORMAT = exports.US_DATE_FORMAT = exports.dayMap = exports.filterFn = exports.setVirtualAmount = exports.hasByMonthDayOrLastDay = exports.frequenciesEditableInterval = exports.getByMonthDaysMap = exports.byDayMap = exports.yearsIntervalMap = exports.monthsIntervalMap = exports.weeksIntervalMap = void 0;
const luxon_1 = require("luxon");
const immutable_1 = require("immutable");
const scheduledTransactionsTypes_1 = require("companion-app-components/flux/scheduled-transactions/scheduledTransactionsTypes");
const scheduledTransactionsUtils_1 = require("companion-app-components/flux/scheduled-transactions/scheduledTransactionsUtils");
const categories_1 = require("companion-app-components/flux/categories");
const getConsecutiveMap = (max, label) => (0, immutable_1.Map)([...Array(max).keys()]
    .map((x) => {
    const index = x + 1;
    return [`${index}`, `${index} ${index > 1 ? label[1] || '' : label[0] || ''}`];
}));
exports.weeksIntervalMap = getConsecutiveMap(10, ['week', 'weeks']); // 1 week to 10 weeks
exports.monthsIntervalMap = getConsecutiveMap(12, ['month', 'months']); // 1 month to 12 month
exports.yearsIntervalMap = getConsecutiveMap(15, ['year', 'years']); // 1 year to 15 years
// Week Days -- Monday, Tuesday...
exports.byDayMap = ((shortDays, longDays) => (0, immutable_1.Map)(shortDays.map((short, index) => [short, longDays[index]])))(scheduledTransactionsUtils_1.weekDays, luxon_1.Info.weekdays());
// Month days 1 to max
const getByMonthDaysMap = (max) => (0, immutable_1.Map)([...Array(max).keys()].map((i) => {
    const n = i + 1;
    return [`${n}`, `${n}${['st', 'nd', 'rd'][((((n + 90) % 100) - 10) % 10) - 1] || 'th'}`];
}));
exports.getByMonthDaysMap = getByMonthDaysMap;
exports.frequenciesEditableInterval = [
    scheduledTransactionsUtils_1.frequencyAliasTypes.dayQuicken,
    scheduledTransactionsUtils_1.frequencyAliasTypes.weeklyQuicken,
    scheduledTransactionsUtils_1.frequencyAliasTypes.monthlyQuicken,
    scheduledTransactionsUtils_1.frequencyAliasTypes.twiceAMonthQuicken,
    scheduledTransactionsUtils_1.frequencyAliasTypes.yearlyQuicken,
    scheduledTransactionsUtils_1.frequencyAliasTypes.twiceAYearQuicken,
];
const hasByMonthDayOrLastDay = (virtualRecurrence) => Object.keys(virtualRecurrence).includes(scheduledTransactionsUtils_1.RECURRANCE_TYPES.byMonthDayOrLastDay)
    && virtualRecurrence.byMonthDayOrLastDay !== null && virtualRecurrence.byMonthDayOrLastDay !== undefined;
exports.hasByMonthDayOrLastDay = hasByMonthDayOrLastDay;
const setVirtualAmount = (schTxn, amount) => {
    const negator = (0, scheduledTransactionsUtils_1.negatorFromType)(schTxn.type);
    return Math.abs(amount) * negator;
};
exports.setVirtualAmount = setVirtualAmount;
const filterFn = (coa, type) => {
    if (!type) {
        return true;
    }
    if (type === scheduledTransactionsTypes_1.STTypeEnum.BILL || type === scheduledTransactionsTypes_1.STTypeEnum.EXPENSE) {
        return categories_1.categoriesSelectors.isExpenseCat(null, coa.id) || coa.type === 'BALANCE_ADJUSTMENT' || coa.type === 'UNCATEGORIZED';
    }
    if (type === scheduledTransactionsTypes_1.STTypeEnum.SUBSCRIPTION) {
        return categories_1.categoriesSelectors.isExpenseCat(null, coa.id) || coa.type === 'UNCATEGORIZED';
    }
    if (type === scheduledTransactionsTypes_1.STTypeEnum.INCOME) {
        return categories_1.categoriesSelectors.isIncomeCat(null, coa.id) || coa.type === 'UNCATEGORIZED';
    }
    if (type === scheduledTransactionsTypes_1.STTypeEnum.TRANSFER) {
        return coa.type === 'ACCOUNT';
    }
    return true;
};
exports.filterFn = filterFn;
exports.dayMap = {
    SU: 0,
    MO: 1,
    TU: 2,
    WE: 3,
    TH: 4,
    FR: 5,
    SA: 6, // Saturday
};
exports.US_DATE_FORMAT = 'M/d/yyyy'; // valid for 'MM/dd/yyyy' format also
exports.LONG_MONTH_DATE_FORMAT = 'LL/dd';
exports.SHORT_DATE_FORMAT = 'MM/dd';
exports.ISO_DATE_FORMAT = 'yyyy-MM-dd';
